import * as fromDatatype from '../datatype-library/index';
import { LocationClassConstants} from '../../sdk/Location/location-class-constants'

export interface bl_inv_mst_location_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  outlet_type_guid: fromDatatype.GuidDataFieldInterface;
  outlet_size_guid: fromDatatype.GuidDataFieldInterface;
  guid_bl_fi_mst_comp: fromDatatype.GuidDataFieldInterface;
  guid_bl_fi_mst_branch: fromDatatype.GuidDataFieldInterface;
  descr: fromDatatype.TextDatatypeInterface;
  name: fromDatatype.TextDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  modified_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  modified_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  location_type: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  address_line_1: fromDatatype.VarcharDatatypeInterface;
  address_line_2: fromDatatype.VarcharDatatypeInterface;
  address_line_3: fromDatatype.VarcharDatatypeInterface;
  address_line_4: fromDatatype.VarcharDatatypeInterface;
  address_line_5: fromDatatype.VarcharDatatypeInterface;
  postal_code: fromDatatype.VarcharDatatypeInterface;
  city: fromDatatype.VarcharDatatypeInterface;
  state: fromDatatype.VarcharDatatypeInterface;
  country: fromDatatype.VarcharDatatypeInterface;
  location_class: LocationClassConstants.LocationClass;
}

export class bl_inv_mst_location_RowClass
  implements bl_inv_mst_location_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  outlet_type_guid: fromDatatype.GuidDataFieldInterface;
  outlet_size_guid: fromDatatype.GuidDataFieldInterface;
  guid_bl_fi_mst_comp: fromDatatype.GuidDataFieldInterface;
  guid_bl_fi_mst_branch: fromDatatype.GuidDataFieldInterface;
  descr: fromDatatype.TextDatatypeInterface;
  name: fromDatatype.TextDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  modified_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  modified_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  location_type: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  address_line_1: fromDatatype.VarcharDatatypeInterface;
  address_line_2: fromDatatype.VarcharDatatypeInterface;
  address_line_3: fromDatatype.VarcharDatatypeInterface;
  address_line_4: fromDatatype.VarcharDatatypeInterface;
  address_line_5: fromDatatype.VarcharDatatypeInterface;
  postal_code: fromDatatype.VarcharDatatypeInterface;
  city: fromDatatype.VarcharDatatypeInterface;
  state: fromDatatype.VarcharDatatypeInterface;
  country: fromDatatype.VarcharDatatypeInterface;
  location_class: LocationClassConstants.LocationClass;
}
